// src/components/scan/ScanHistory/ScanHistory.tsx
import { useIsMobile } from '../../../../utils/isMobile';
import Desktop from './ScanHistoryDesktop';
import Mobile  from './ScanHistoryMobile';
import type { ScanHistoryProps } from './ScanHistoryDesktop';

const ScanHistory = (props: ScanHistoryProps) => {
  const isMobile = useIsMobile();
  return isMobile ? <Mobile {...props} /> : <Desktop {...props} />;
};

export default ScanHistory;
